<div class="content">
  <div class="treeHeader" (click)="toggleExpansion()">
    <mat-icon class="size-16">{{ expanded() ? 'expand_more' : 'chevron_right' }}</mat-icon>
    <label class="titleLabel">{{ title }}</label>
  </div>
  @if (expanded()) {
    <div class="childNodes">
      @for (child of children; track child) {
        <div class="nodeWrapper">
          <app-documentation-node [sharingAllowed]="sharingAllowed()" [node]="child" [selectedCategory]="selectedCategory()"
            (downloadRequested)="downloadFile($event)"
          (shareRequested)="shareFile($event)"></app-documentation-node>
        </div>
      }
    </div>
  }
</div>
